import { Drawer } from "antd";
import { useAtomValue } from "jotai";

import SidePanelCloseListener from "./side-panel-close-listener";
import { getSidePanelWidth } from "./side-panel.helper";
import { useSidePanel } from "./side-panel.hook";
import { sidePanelAtom } from "./side-panel.state";

import "./side-panel.style.less";

const SidePanel = () => {
  const { visible, title, component, size } = useAtomValue(sidePanelAtom);
  const { closeSidePanel } = useSidePanel();

  return (
    <>
      <SidePanelCloseListener />
      <Drawer
        open={visible}
        onClose={closeSidePanel}
        footer={<div id="side-panel-footer-placeholder" />}
        mask={{ closable: false }}
        placement="right"
        size={getSidePanelWidth(size)}
        title={<span role="heading">{title}</span>}
        className="side-panel"
      >
        {component}
      </Drawer>
    </>
  );
};

export default SidePanel;
